<template>
  <div class="home">
    <router-view />
  </div>
</template>
<script>
export default {
  name: "Index",
  data() {
    return {};
  },
  created() {},
  methods: {},
};
</script>
<style lang="less" scoped>
.home {
  background: #f6f6f6;
  height: 100vh;
  padding: 19px 30px;
}
</style>
